import React from 'react'
import './TeamHeader.css'

function TeamHeader() {
  return (
	<div className="team-header">
            <div
                className="team-header-container"
            >
                <h1 className="team-header-title">
                    Meet the team
                </h1>
            </div>
        </div>
  )
}

export default TeamHeader